module.exports = __webpack_public_path__ + "img/surf-giveaways-logo--white.821670dd.svg";